import React, { FunctionComponent, useEffect, useState } from 'react';
import { pathOr } from 'ramda';
import withStyles from 'react-jss';
import { Popup } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import { useGetMarketplaces } from 'helpers/useGetMarketplaces';

type Props = {
  classes: ClassProp<typeof styles>;
  fieldValue: string[];
  record?: Record<string, any>;
  source: Array<number | string>;
  options?: Record<string, unknown>;
};

const styles = {
  listItems: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
};

type Classes = ClassProp<typeof styles>;

const renderMarketPlaces = (
  marketplaces: Array<string>,
  classes: Classes,
): JSX.Element => {
  if (marketplaces.length <= 2) {
    return (
      <ul className={classes.listItems}>
        {marketplaces.map((marketplace, idx) => (
          <li key={`marketplace_${idx}`}>{marketplace}</li>
        ))}
      </ul>
    );
  }

  return (
    <>
      <span>
        {`${marketplaces[0]}, ${marketplaces[1]}, ${marketplaces[2]}`}
      </span>
      <Popup
        trigger={
          marketplaces.length > 3 && (
            <span style={{ textDecoration: 'underline dotted' }}>
              {` and ${marketplaces.length - 3}  more`}
            </span>
          )
        }
      >
        <Popup.Content>{marketplaces.join(', ')}</Popup.Content>
      </Popup>
    </>
  );
};

const MarketPlacesPopUp: FunctionComponent<Props> = ({
  record,
  classes,
  source,
}) => {
  const [marketplaces, setMarketPlaces] = useState<string[]>(
    pathOr('', source, record) as string[],
  );
  const { marketplacesMap } = useGetMarketplaces();

  useEffect(() => {
    if (marketplacesMap.size !== 0) {
      const temp = marketplaces
        .map(
          (marketplace) =>
            marketplacesMap.get(marketplace.toLowerCase()) ||
            marketplace.toLowerCase(),
        )
        .filter((m) => m !== '');
      setMarketPlaces(temp);
    }
  }, [marketplacesMap]);

  return renderMarketPlaces(marketplaces, classes);
};

export default withStyles(styles)(MarketPlacesPopUp);
